import React from "react"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { patchAccount, patchSpecificAccount } from "../../../actions/AccountActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { IUserRole, IAccountDocument } from "../../../models"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as api from "../../../api"
import AppStateStore from "../../../stores/AppStateStore"
import AccountPerEmployeePerMonthRate from "./AccountPerEmployeePerMonthRate"
import _ from "lodash"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import accountStore from "../../../stores/AccountStore"
import InfoIconToggle from "../../common/InfoIconToggle"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"

interface IProps {
    account: IAccountDocument
    readOnly?: boolean

    // from Account->manager
    accountManager?: boolean
    updateLoadedAccount?(account: IAccountDocument): Promise<IAccountDocument>
}
interface IState {
    enableTimecards: boolean
    enableCreateEmptyTimecard: boolean
    enableEquipment: boolean
    enablePayrollWorkflow: boolean
    enablePayrollLambda: boolean
    showEmptyEmployeePayroll: boolean
    enableExpenses: boolean
    enableTimecardTimeExpenses: boolean
    enableTimecardAmountExpenses: boolean
    expenseIsPayrollTime: boolean
    enablePriorPeriodAdjustments: boolean
    enableAccrualsTimeoff: boolean
    enableManualAccrualAdjustment: boolean
    oneHourTimeoffIncrement: boolean
    enableSchedule: boolean
    enableWorkAvailavility: boolean
    onlyLockSupApproved: boolean
    enableEmployeeApproveTimecard: boolean
    enableExtSupApproveTimecard: boolean
    onlyLockEmpApproved: boolean
    enableSupervisorDirectReport: boolean
    enableJobs: boolean
    enablePhases: boolean
    enableAssignJobPunch: boolean
    enablePunchSplit: boolean
    enablePayClass: boolean
    enableUseBasePayRateInPayClass: boolean
    enableClients: boolean
    enableHR: boolean
    enableCRM: boolean
    enableCalculationDayGroup: boolean
    enableFinddPolicy: boolean
    enablePunchRule: boolean
    enablePunchRuleStage: boolean
    recalcTimecardByShift: boolean
    forceEmployeeAccountPosition: boolean
    hideBilling: boolean
    enableCustomRoundingRule: boolean
    enableRateTotals: boolean
    showPayrollRates: boolean
    enableWorkflows: boolean
    allowSTRIPEPaymentMethod: boolean
    hidePaywall: boolean
    excludeExemptEmpPayroll: boolean
    excludeAgencyEmpPayroll: boolean
    hideOT2: boolean
    enableOTPolicy: boolean
    enableDailyScheduleBudget: boolean
    enableResourcePlannerSchedule: boolean
    enableWorkInstructions: boolean
    allowMobileLocationFraudPreventionOnDevice: boolean
    enableNoteAttributes: boolean
    disableEmployeeApprovalException: boolean
    disableSupervisorApprovalException: boolean
    disableLocationExceptionWhenNoGPS: boolean
    enableBreadcrumb: boolean
    medicalAccount: boolean
    enableCAMealBreakNotification: boolean
    eanbleChatGPTAutoRespondToSMS: boolean
    enableBlendedRateOvertime: boolean
    enablePayGroupAssignEmployeeLevel: boolean
    showPayClassOnESS: boolean
    resolveSuspensePunch: boolean
    enableEmployeeLock: boolean
    enableJobTimezone: boolean
    enableSupervisorLock: boolean
    enableTrends: boolean
    allowTimeOffPayRateEdit: boolean
    enableATS: boolean
    hideParentPunchSetsInPayroll: boolean
    enableSimpleWorkPreferences: boolean
    enableIVR: boolean,
    enableDidiNotifications: boolean
    disableAccrualCalculationForPayroll: boolean
    enableMessageCenter: boolean
    enableUserEffectiveDoc: boolean
}

export default class AccountFeatureSettings extends React.Component<IProps, IState> {
    private accountOwnerRoles: IUserRole[] = []
    constructor(props: IProps) {
        super(props)
        this.state = this.getStateData(props)
        autobind(this)
        this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(props.account)
    }

    getStateData(props: IProps) {
        const featureSettings = props.account.AccountSettings.FeatureSettings
        const stateData: IState = {
            enableTimecards: featureSettings.EnableTimecards,
            enableCreateEmptyTimecard: featureSettings.EnableCreateEmptyTimecard,
            enableEquipment: featureSettings.EnableEquipment,
            enablePayrollWorkflow: featureSettings.EnablePayrollWorkflow,
            enablePayrollLambda: featureSettings.EnablePayrollLambda,
            enableExpenses: featureSettings.EnableExpenses,
            enableAccrualsTimeoff: featureSettings.EnableAccrualsTimeoff,
            enableSchedule: featureSettings.EnableSchedule,
            enableWorkAvailavility: featureSettings.EnableWorkAvailability,
            onlyLockSupApproved: featureSettings.OnlyLockSupApproved,
            enableEmployeeApproveTimecard: featureSettings.EnableEmployeeApproveTimecard,
            enableExtSupApproveTimecard: featureSettings.EnableExtSupApproveTimecard,
            onlyLockEmpApproved: featureSettings.OnlyLockEmpApproved,
            enableSupervisorDirectReport: featureSettings.EnableSupervisorDirectReport,
            enableClients: featureSettings.EnableClients,
            enableJobs: featureSettings.EnableJobs,
            enablePhases: featureSettings.EnablePhases,
            enableAssignJobPunch: featureSettings.EnableAssignJobPunch,
            enablePunchSplit: featureSettings.EnablePunchSplit,
            enableCRM: featureSettings.EnableCRM,
            enablePayClass: featureSettings.EnablePayClass,
            enableUseBasePayRateInPayClass: featureSettings.EnableUseBasePayRateInPayClass,
            enableHR: featureSettings.EnableHR,
            enableCalculationDayGroup: featureSettings.EnableCalculationDayGroup,
            enableManualAccrualAdjustment: featureSettings.EnableManualAccrualAdjustment,
            oneHourTimeoffIncrement: featureSettings.OneHourTimeoffIncrement,
            enableFinddPolicy: featureSettings.EnableFinddPolicy,
            enablePunchRule: featureSettings.EnablePunchRule,
            enablePunchRuleStage: featureSettings.EnablePunchRuleStage,
            recalcTimecardByShift: featureSettings.RecalcTimecardByShift,
            forceEmployeeAccountPosition: featureSettings.ForceEmployeeAccountPosition,
            hideBilling: featureSettings.HideBilling,
            enableCustomRoundingRule: featureSettings.EnableCustomRoundingRule,
            enableRateTotals: featureSettings.EnableRateTotals,
            enableTimecardTimeExpenses: featureSettings.EnableTimecardExpenses,
            enableTimecardAmountExpenses: featureSettings.EnableTimecardAmountExpenses,
            expenseIsPayrollTime: featureSettings.ExpenseIsPayrollTime,
            showEmptyEmployeePayroll: featureSettings.ShowEmptyEmployeePayroll,
            showPayrollRates: featureSettings.ShowPayrollRates,
            enablePriorPeriodAdjustments: featureSettings.EnablePriorPeriodAdjustments,
            enableWorkflows: featureSettings.EnableWorkflows,
            allowSTRIPEPaymentMethod: featureSettings.AllowSTRIPEPaymentMethod,
            hidePaywall: featureSettings.HidePaywall,
            excludeExemptEmpPayroll: featureSettings.ExcludeExemptEmpPayroll,
            excludeAgencyEmpPayroll: featureSettings.ExcludeAgencyEmpPayroll,
            hideOT2: featureSettings.HideOT2,
            enableOTPolicy: featureSettings.EnableOTPolicy,
            enableDailyScheduleBudget: featureSettings.DailyScheduleBudget,
            enableResourcePlannerSchedule: featureSettings.ResourcePlannerSchedule,
            enableWorkInstructions: featureSettings.WorkInstructions,
            allowMobileLocationFraudPreventionOnDevice: featureSettings.AllowMobileLocationFraudPreventionOnDevice,
            enableNoteAttributes: featureSettings.EnableNoteAttributes,
            disableEmployeeApprovalException: featureSettings.DisableEmployeeApprovalException,
            disableSupervisorApprovalException: featureSettings.DisableSupervisorApprovalException,
            disableLocationExceptionWhenNoGPS: featureSettings.DisableLocationExceptionWhenNoGPS,
            enableBreadcrumb: featureSettings.EnableBreadcrumb,
            medicalAccount: featureSettings.MedicalAccount,
            enableCAMealBreakNotification: featureSettings.EnableCAMealBreakNotification,
            eanbleChatGPTAutoRespondToSMS: featureSettings.ChatGPTAutoRespondToSMS,
            enablePayGroupAssignEmployeeLevel: featureSettings.EnablePayGroupAssignEmployeeLevel,
            showPayClassOnESS: featureSettings.ShowPayClassOnESS,
            resolveSuspensePunch: featureSettings.ResolveSuspensePunch,
            enableBlendedRateOvertime: featureSettings.EnableBlendedRateOvertime,
            enableEmployeeLock: featureSettings.EnableEmpLock,
            enableJobTimezone: featureSettings.EnableJobTimezone,
            enableSupervisorLock: featureSettings.EnableSupLock,
            enableTrends: featureSettings.EnableTrends,
            allowTimeOffPayRateEdit: featureSettings.AllowTimeOffPayRateEdit,
            enableATS: featureSettings.EnableATS,
            enableIVR: featureSettings.EnableIVR,
            hideParentPunchSetsInPayroll: featureSettings.HideParentPunchSetsInPayroll,
            enableSimpleWorkPreferences: featureSettings.EnableSimpleWorkPreferences,
            enableDidiNotifications: featureSettings.EnableDidiNotifications,
            disableAccrualCalculationForPayroll: featureSettings.DisableAccrualCalculationForPayroll,
            enableMessageCenter: featureSettings.EnableMessageCenter,
            enableUserEffectiveDoc: featureSettings.EnableUserEffectiveDoc,
        }
        return stateData
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.account.AccountSettings.FeatureSettings, nextProps.account.AccountSettings.FeatureSettings) &&
            this.setState(this.getStateData(nextProps))
    }

    handleUpdateAccount(account, cb = null) {
        this.props.accountManager ?
            patchSpecificAccount(this.props.account.Id, account, this.props.account.TicksSinceChange,
                res => this.props.updateLoadedAccount(res.data as IAccountDocument).then(() => {
                    cb && cb()
                })
            ) :
            patchAccount(this.props.account.Id, account, cb)
    }

    handleToggleEnableTimecards(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                const enablePayrollWorkflow = value ? (this.state.enablePayrollWorkflow ? true : false) : false
                const enablePayrollLambda = enablePayrollWorkflow ? (this.state.enablePayrollLambda ? true : false) : false
                const enableCreateEmptyTimecard = value ? (this.state.enableCreateEmptyTimecard ? true : false) : false
                const enablePayGroupAssignEmployeeLevel = enablePayrollWorkflow ? (this.state.enablePayGroupAssignEmployeeLevel ? true : false) : false
                this.setState({ enableTimecards: value, enablePayrollWorkflow, enablePayrollLambda, enableCreateEmptyTimecard, enablePayGroupAssignEmployeeLevel }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableTimecards: value, EnablePayrollWorkflow: enablePayrollWorkflow, EnablePayrollLambda: enablePayrollWorkflow, EnableCreateEmptyTimecard: enableCreateEmptyTimecard } } }, () =>
                        this.setAccountUserRolesForFeature(value ? ["Timecards"] : ["Timecards", "Payroll"], value)
                    )
                )
            }
        })
    }

    handleToggleEnableCreateEmptyTimecard(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                this.setState({ enableCreateEmptyTimecard: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableCreateEmptyTimecard: value } } })
                )
            }
        })
    }

    handleToggleEnableEquipment(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                this.setState({ enableEquipment: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableEquipment: value } } }, () =>
                        this.setAccountUserRolesForFeature(["Equipment"], value)
                    )
                )
            }
        })
    }

    handleToggleEnablePayrollWorkflow(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                const enableTimecards = value ? true : this.state.enableTimecards ? true : false
                const enablePayrollLambda = value && this.state.enablePayrollLambda ? true : false
                const showEmptyEmployeePayroll = value && this.state.showEmptyEmployeePayroll ? true : false
                const onlyLockSupApproved = value && this.state.onlyLockSupApproved ? true : false
                const onlyLockEmpApproved = value && this.state.onlyLockEmpApproved ? true : false
                const enablePayGroupAssignEmployeeLevel = value && this.state.enablePayGroupAssignEmployeeLevel ? true : false
                const enableOTPolicy = value && this.state.enableOTPolicy ? true : false
                const enableEmployeeLock = value && this.state.enableEmployeeLock ? true : false
                const enableSupervisorLock = value && this.state.enableSupervisorLock ? true : false
                const disableAccrualCalculationForPayroll = value && this.state.disableAccrualCalculationForPayroll ? true : false
                this.setState({
                    enablePayrollWorkflow: value,
                    enablePayrollLambda,
                    showEmptyEmployeePayroll,
                    enableTimecards,
                    onlyLockSupApproved,
                    onlyLockEmpApproved,
                    enablePayGroupAssignEmployeeLevel,
                    enableOTPolicy,
                    enableEmployeeLock,
                    enableSupervisorLock,
                    disableAccrualCalculationForPayroll
                }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: {
                            FeatureSettings: {
                                EnablePayrollWorkflow: value,
                                EnablePayrollLambda: enablePayrollLambda,
                                ShowEmptyEmployeePayroll: showEmptyEmployeePayroll,
                                EnableTimecards: enableTimecards,
                                OnlyLockSupApproved: onlyLockSupApproved,
                                OnlyLockEmpApproved: onlyLockEmpApproved,
                                EnablePayGroupAssignEmployeeLevel: enablePayGroupAssignEmployeeLevel,
                                EnableOTPolicy: enableOTPolicy,
                                EnableEmpLock: enableEmployeeLock,
                                EnableSupLock: enableSupervisorLock,
                                DisableAccrualCalculationForPayroll: disableAccrualCalculationForPayroll
                            }
                        }
                    }, () =>
                        this.setAccountUserRolesForFeature(value ? ["Timecards", "Payroll"] : ["Payroll"], value)
                    )
                })
            }
        })
    }

    handleToggleDisableAccrualCalculationForPayroll(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ disableAccrualCalculationForPayroll: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { DisableAccrualCalculationForPayroll: value } } })
                )
        })
    }

    handleToggleEnablePayrollLambda(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enablePayrollLambda: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePayrollLambda: value } } })
                )
        })
    }

    handleToggleShowEmptyEmployeePayroll(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ showEmptyEmployeePayroll: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ShowEmptyEmployeePayroll: value } } })
                )
        })
    }

    handleToggleEnableExpenses(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const enableTimecardTimeExpenses = value && this.state.enableTimecardTimeExpenses ? true : false
                const enableTimecardAmountExpenses = value && this.state.enableTimecardAmountExpenses ? true : false
                const expenseIsPayrollTime = value && this.state.expenseIsPayrollTime ? true : false
                const enablePriorPeriodAdjustments = value && this.state.enablePriorPeriodAdjustments ? true : false
                const onlyLockEmpApproved = !value && !this.state.enableEmployeeApproveTimecard ? false : this.state.onlyLockEmpApproved
                this.setState({
                    enableExpenses: value,
                    enableTimecardTimeExpenses,
                    enableTimecardAmountExpenses,
                    expenseIsPayrollTime,
                    enablePriorPeriodAdjustments,
                    onlyLockEmpApproved
                }, () =>
                    this.handleUpdateAccount({
                        AccountSettings: {
                            FeatureSettings: {
                                EnableExpenses: value,
                                EnableTimecardExpenses: enableTimecardTimeExpenses,
                                EnableTimecardAmountExpenses: enableTimecardAmountExpenses,
                                ExpenseIsPayrollTime: expenseIsPayrollTime,
                                EnablePriorPeriodAdjustments: enablePriorPeriodAdjustments,
                                OnlyLockEmpApproved: onlyLockEmpApproved
                            }
                        }
                    })
                )
            }
        })
    }

    handleToggleEnableTimecardTimeExpenses(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const enableTimecardAmountExpenses = value && this.state.enableTimecardAmountExpenses ? true : false
                const enablePriorPeriodAdjustments = value && this.state.enablePriorPeriodAdjustments ? true : false
                this.setState({ enableTimecardTimeExpenses: value, enableTimecardAmountExpenses, enablePriorPeriodAdjustments }, () =>
                    this.handleUpdateAccount(
                        { AccountSettings: { FeatureSettings: { EnableTimecardExpenses: value, EnableTimecardAmountExpenses: enableTimecardAmountExpenses, EnablePriorPeriodAdjustments: enablePriorPeriodAdjustments } } },
                        () => {
                            if (!value) return
                            const accountUserRoles = this.props.account.AccountSettings.UserRoles || []
                            accountUserRoles.forEach(role => {
                                role.Permissions = this.setPermission(role.Permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, role.Permissions.includes(AuthenticationStore.Permissions.Timecards.ViewTimecards))
                                role.Permissions = this.setPermission(role.Permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, role.Permissions.includes(AuthenticationStore.Permissions.Payroll.ViewPayroll))
                                role.Permissions = this.setPermission(role.Permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, role.Permissions.includes(AuthenticationStore.Permissions.Payroll.LockPayroll))
                                role.Permissions = this.setPermission(role.Permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, role.Permissions.includes(AuthenticationStore.Permissions.Payroll.ClosePayroll))
                                role.Permissions = this.setPermission(role.Permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, role.Permissions.includes(AuthenticationStore.Permissions.Payroll.ExportPayroll))
                            })
                            this.handleUpdateAccount({ AccountSettings: { UserRoles: accountUserRoles } })
                        }
                    )
                )
            }
        })
    }

    setPermission(permissions, permission, value) {
        if (value) {
            !permissions.includes(permission) && permissions.push(permission)
        } else {
            permissions.includes(permission) && permissions.splice(permissions.indexOf(permission), 1)
        }
        return permissions
    }

    handleToggleEnableTimecardAmountExpenses(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.setState({ enableTimecardAmountExpenses: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableTimecardAmountExpenses: value } } })
                })
            }
        })
    }

    handleToggleExpenseIsPayrollTime(expenseIsPayrollTime: boolean) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.setState({ expenseIsPayrollTime }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ExpenseIsPayrollTime: expenseIsPayrollTime } } })
                })
            }
        })
    }

    handleToggleEnablePriorPeriodAdjustments(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enablePriorPeriodAdjustments: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePriorPeriodAdjustments: value } } })
                })
        })
    }

    handleToggleEnableAccrualsTimeoff(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                const enableManualAccrualAdjustment = value && this.state.enableManualAccrualAdjustment ? true : false
                const oneHourTimeoffIncrement = value && this.state.oneHourTimeoffIncrement ? true : false
                this.setState({ enableAccrualsTimeoff: value, enableManualAccrualAdjustment, oneHourTimeoffIncrement }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableAccrualsTimeoff: value, EnableManualAccrualAdjustment: enableManualAccrualAdjustment, OneHourTimeoffIncrement: oneHourTimeoffIncrement } } }, () =>
                        this.setAccountUserRolesForFeature(["Accrual", "LeaveTracking"], value)
                    )
                })
            }
        })
    }

    handleToggleEnableSchedule(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                const enableWorkAvailavility = value && this.state.enableWorkAvailavility ? true : false
                this.setState({ enableSchedule: value, enableWorkAvailavility }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableSchedule: value, EnableWorkAvailability: enableWorkAvailavility } } }, () =>
                        this.setAccountUserRolesForFeature(["Schedule"], value)
                    )
                })
            }
        })
    }

    handleToggleEnableWorkAvailability(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                this.setState({ enableWorkAvailavility: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableWorkAvailability: value } } })
                })
            }
        })
    }

    handleToggleEnableEmployeeApproveTimecard(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const onlyLockEmpApproved = !value && !this.state.enableExpenses ? false : this.state.onlyLockEmpApproved
                this.setState({ enableEmployeeApproveTimecard: value, onlyLockEmpApproved }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: {
                            FeatureSettings: {
                                EnableEmployeeApproveTimecard: value,
                                EnableEmpTimecardApproveAttestation: value ? this.props.account.AccountSettings.FeatureSettings.EnableEmpTimecardApproveAttestation : false,
                                EmpTimecardApproveAttestation: value ? this.props.account.AccountSettings.FeatureSettings.EmpTimecardApproveAttestation : null,
                                OnlyLockEmpApproved: onlyLockEmpApproved,
                                DisableEmployeeApprovalException: value ? this.state.disableEmployeeApprovalException : true
                            }
                        }
                    })
                })
            }
        })
    }

    handleToggleEnableExtSupApproveTimecard(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.setState({ enableExtSupApproveTimecard: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableExtSupApproveTimecard: value } }
                    })
                })
            }
        })
    }

    handleToggleOnlyLockEmpApproved(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ onlyLockEmpApproved: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { OnlyLockEmpApproved: value } }
                    })
                })
        })
    }

    handleToggleEnableSupervisorDirectReport(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.accountOwnerRoles = permissionHelper.getAccountOwnerRoles(this.props.account)
                this.setState({ enableSupervisorDirectReport: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableSupervisorDirectReport: value } } }, () =>
                        this.setAccountUserRolesForFeature(["SupervisorDirectReport"], value)
                    )
                })
            }
        })
    }

    handleToggleEnableJobs(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const enablePhases = value && this.state.enablePhases ? true : false
                const enableAssignJobPunch = value && this.state.enableAssignJobPunch ? true : false
                const enableJobTimezone = value && this.state.enableJobTimezone ? true : false
                this.handleEnableAssignJobPunch(enableAssignJobPunch)
                this.setState({ enableJobs: value, enablePhases, enableAssignJobPunch, enableJobTimezone }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableJobs: value, EnablePhases: enablePhases, EnableAssignJobPunch: enableAssignJobPunch, EnableJobTimezone: enableJobTimezone } } })
                })
            }
        })
    }

    handleToggleEnablePhases(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enablePhases: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePhases: value } } })
                })
        })
    }

    handleToggleEnableAssignJobPunch(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableAssignJobPunch: value }, () => {
                    this.handleEnableAssignJobPunch(value)
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableAssignJobPunch: value } } })
                })
        })
    }

    handleToggleEnableJobTimezone(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableJobTimezone: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableJobTimezone: value } } })
                })
        })
    }

    handleEnableAssignJobPunch(enableAssignJobPunch: boolean) {
        this.props.account.AccountSettings.FeatureSettings.EnableAssignJobPunch &&
            !enableAssignJobPunch &&
            api.disableAssignJobPunch(this.props.account.Id)
    }

    handleToggleEnableClients(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const enableHR = value && this.state.enableHR ? true : false
                const enableCRM = value && this.state.enableHR && this.state.enableCRM ? true : false
                const showPayClassOnESS = enableCRM && this.state.showPayClassOnESS ? true : false
                this.setState({ enableClients: value, enableHR, enableCRM, showPayClassOnESS }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableClients: value, EnableHR: enableHR, EnableCRM: enableCRM, ShowPayClassOnESS: showPayClassOnESS } } })
                })
            }
        })
    }

    handleToggleEnableHR(event, value) {
        value ?
            AppStateStore.setConfirmDialogContent({
                content: strings.Are_you_sure_you_want_to_turn_on_HR,
                confirm: () => this.handleSaveHR(true)
            }) :
            AppStateStore.setConfirmDialogContent({
                content: strings.Are_you_sure_you_want_to_change_this_account_setting,
                confirm: () => this.handleSaveHR(false)
            })
    }

    handleSaveHR(value: boolean) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const enableCRM = value && this.state.enableCRM ? true : false
                const showPayClassOnESS = enableCRM && this.state.showPayClassOnESS ? true : false
                this.setState({ enableHR: value, enableCRM, showPayClassOnESS }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableHR: value, EnableCRM: enableCRM, ShowPayClassOnESS: showPayClassOnESS } } },
                        () => {
                            if (value) {
                                AppStateStore.setProgressSnackbarContent("loading")
                                api.createAccountHRISSettingsFromAccount().then(() =>
                                    AppStateStore.setProgressSnackbarContent(strings.HR_was_successfully_created)
                                )
                            }
                        }
                    )
                })
            }
        })
    }


    handleToggleDisableEmployeeApprovalException(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ disableEmployeeApprovalException: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { DisableEmployeeApprovalException: value } } })
                })
        })
    }


    handleToggleDisableSupervisorApprovalException(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ disableSupervisorApprovalException: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { DisableSupervisorApprovalException: value } } })
                })
        })
    }


    handleToggleDisableLocationExceptionWhenNoGPS(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ disableLocationExceptionWhenNoGPS: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { DisableLocationExceptionWhenNoGPS: value } } })
                })
        })
    }

    handleToggleMedicalAccount(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ medicalAccount: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { MedicalAccount: value } } })
                })
        })
    }

    handleToggleEnableNoteAttributes(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableNoteAttributes: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableNoteAttributes: value } } })
                })
        })
    }

    handleToggleEnableCRM(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const showPayClassOnESS = value && this.state.showPayClassOnESS ? true : false
                this.setState({ enableCRM: value, showPayClassOnESS }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableCRM: value, ShowPayClassOnESS: showPayClassOnESS } } })
                })
            }
        })
    }

    handleToggleEnablePayClass(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const showPayClassOnESS = value && this.state.showPayClassOnESS ? true : false
                this.setState({ enablePayClass: value, showPayClassOnESS }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePayClass: value, ShowPayClassOnESS: showPayClassOnESS } } })
                })
            }
        })
    }

    handleToggleEnableUseBasePayRateInPayClass(event, value) {
        console.log(value, "value")
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                const showPayClassOnESS = value && this.state.enablePayClass && this.state.showPayClassOnESS ? true : false
                this.setState({ enableUseBasePayRateInPayClass: value, showPayClassOnESS }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { enableUseBasePayRateInPayClass: value, ShowPayClassOnESS: showPayClassOnESS } } })
                })
            }
        })
    }

    handleToggleShowPayClassOnESS(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ showPayClassOnESS: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ShowPayClassOnESS: value } } })
                })
        })
    }

    handleToggleEnablePunchSplit(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enablePunchSplit: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePunchSplit: value } } })
                })
        })
    }

    handleToggleEnableCalculationDayGroup(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableCalculationDayGroup: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableCalculationDayGroup: value } } })
                })
        })
    }

    handleToggleEnableManualAccrualAdjustment(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableManualAccrualAdjustment: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableManualAccrualAdjustment: value } } })
                })
        })
    }

    handleToggleOneHourTimeoffIncrement(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ oneHourTimeoffIncrement: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { OneHourTimeoffIncrement: value } } })
                })
        })
    }

    handleToggleEnableFinddPolicy(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableFinddPolicy: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableFinddPolicy: value } } })
                })
        })
    }

    handleToggleEnablePunchRule(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.setState({ enablePunchRule: value, recalcTimecardByShift: false, enablePunchRuleStage: false }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePunchRule: value, EnablePunchRuleStage: false, RecalcTimecardByShift: false } } })
                })
            }
        })
    }

    handleToggleEnablePunchRuleStage(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () => {
                this.setState({ enablePunchRuleStage: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePunchRuleStage: value } } })
                })
            }
        })
    }

    handleToggleRecalcTimecardByShift(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ recalcTimecardByShift: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { RecalcTimecardByShift: value } } })
                })
        })
    }

    handleToggleForceEmployeeAccountPosition(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ forceEmployeeAccountPosition: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ForceEmployeeAccountPosition: value } } })
                })
        })
    }

    handleToggleHideBilling(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ hideBilling: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { HideBilling: value } } })
                })
        })
    }

    handleToggleEnableCustomRoundingRule(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableCustomRoundingRule: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableCustomRoundingRule: value } } })
                })
        })
    }

    handleToggleEnableRateTotals(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableRateTotals: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableRateTotals: value } } })
                })
        })
    }

    handleToggleShowPayrollRates(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ showPayrollRates: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ShowPayrollRates: value } } })
                })
        })
    }

    handleToggleEnableWorkflows(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableWorkflows: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableWorkflows: value } } })
                })
        })
    }

    setAccountUserRolesForFeature(featurePermissionNames, value) {
        const accountUserRoles = this.props.account.AccountSettings.UserRoles.slice()
        if (value) {
            const allPermissionsForAccountOwnerRole = permissionHelper.getAllPermissionsForAccountOwnerRole(this.props.account)
            accountUserRoles.forEach(role =>
                this.accountOwnerRoles.find(ownerRole => ownerRole.Id === role.Id) &&
                allPermissionsForAccountOwnerRole.forEach(permission =>
                    !role.Permissions.includes(permission) &&
                    role.Permissions.push(permission)
                )
            )
        }
        else {
            let deleteFeaturePermissions = []
            featurePermissionNames.forEach(name => {
                deleteFeaturePermissions = deleteFeaturePermissions.concat(permissionHelper.getFeaturePermissions(name))
                this.props.account.AccountSettings.FeatureSettings.EnablePayrollWorkflow && name === "Accrual" && deleteFeaturePermissions.push(AuthenticationStore.Permissions.Payroll.ClosePayroll)
                //two schedule permission not exist now
                if (name === "Schedule") deleteFeaturePermissions = deleteFeaturePermissions.concat(["ADD_USER_SCHEDULE", "DELETE_USER_SCHEDULE"])
            })
            accountUserRoles.forEach((item) =>
                item.Permissions = item.Permissions.filter((p) => !deleteFeaturePermissions.includes(p))
            )
        }
        return this.handleUpdateAccount({ AccountSettings: { UserRoles: accountUserRoles } })
    }

    handleToggleAllowSTRIPEPaymentMethod(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ allowSTRIPEPaymentMethod: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { AllowSTRIPEPaymentMethod: value } } })
                })
        })
    }

    handleToggleHidePaywall(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ hidePaywall: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { HidePaywall: value } } })
                })
        })
    }

    handleToggleExcludeExemptEmpPayroll(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ excludeExemptEmpPayroll: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ExcludeExemptEmpPayroll: value } } })
                })
        })
    }

    handleToggleExcludeAgencyEmpPayroll(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ excludeAgencyEmpPayroll: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ExcludeAgencyEmpPayroll: value } } })
                })
        })
    }

    handleToggleResolveSuspensePunch(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ resolveSuspensePunch: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ResolveSuspensePunch: value } } })
                })
        })
    }

    handleToggleEnableEmployeeLock(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableEmployeeLock: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableEmpLock: value } } })
                })
        })
    }

    handleToggleEnableSupervisorLock(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableSupervisorLock: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableSupLock: value } } })
                })
        })
    }

    handleToggleHideOT2(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ hideOT2: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { HideOT2: value } } })
                })
        })
    }

    handleToggleEnableOTPolicy(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableOTPolicy: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnableOTPolicy: value } } })
                })
        })
    }

    handleToggleEnableDailyScheduleBudget(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableDailyScheduleBudget: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { DailyScheduleBudget: value } } })
                })
        })
    }

    handleToggleEnableResourcePlannerSchedule(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableResourcePlannerSchedule: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { ResourcePlannerSchedule: value } } })
                })
        })
    }

    handleToggleEnableWorkInstructions(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableWorkInstructions: value }, () => {
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { WorkInstructions: value } } })
                })
        })
    }

    handleToggleOnlyLockSupApproved(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ onlyLockSupApproved: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { OnlyLockSupApproved: value } }
                    })
                })
        })
    }

    handleToggleAllowMobileLocationFraudPreventionOnDevice(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ allowMobileLocationFraudPreventionOnDevice: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { AllowMobileLocationFraudPreventionOnDevice: value } }
                    })
                })
        })
    }

    handleToggleEnableBreadcrumb(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableBreadcrumb: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableBreadcrumb: value } }
                    })
                })
        })
    }

    handleToggleEnableCAMealBreakNotification(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableCAMealBreakNotification: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableCAMealBreakNotification: value } }
                    })
                })
        })
    }

    handleToggleEanbleChatGPTAutoRespondToSMS(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ eanbleChatGPTAutoRespondToSMS: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { ChatGPTAutoRespondToSMS: value } }
                    })
                })
        })
    }

    handleToggleEnableBlendedRateOvertime(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableBlendedRateOvertime: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableBlendedRateOvertime: value } }
                    })
                })
        })
    }

    handleToggleEnableTrends(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableTrends: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableTrends: value } }
                    })
                })
        })
    }

    handleToggleEnablePayGroupAssignEmployeeLevel(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enablePayGroupAssignEmployeeLevel: value }, () =>
                    this.handleUpdateAccount({ AccountSettings: { FeatureSettings: { EnablePayGroupAssignEmployeeLevel: value } } })
                )
        })
    }

    handleToggleAllowTimeOffPayRateEdit(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ allowTimeOffPayRateEdit: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { allowTimeOffPayRateEdit: value } }
                    })
                })
        })
    }

    handleToggleEnableATS(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableATS: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableATS: value } }
                    })
                })
        })
    }

    handleToggleEnableIVR(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableIVR: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableIVR: value } }
                    })
                })
        })
    }

    handleHideParentPunchSetsInPayroll(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ hideParentPunchSetsInPayroll: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { HideParentPunchSetsInPayroll: value } }
                    })
                })
        })
    }

    handleToggleEnableDidiNotifications(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableDidiNotifications: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableDidiNotifications: value } }
                    })
                })
        })
    }

    handleToggleEnableSimpleWorkPreferences(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableSimpleWorkPreferences: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableSimpleWorkPreferences: value } }
                    })
                })
        })
    }

    handleToggleEnableMessageCenter(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableMessageCenter: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableMessageCenter: value } }
                    })
                })
        })
    }

    handleToggleEnableUserEffectiveDoc(event, value) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_change_this_account_setting,
            confirm: () =>
                this.setState({ enableUserEffectiveDoc: value }, () => {
                    this.handleUpdateAccount({
                        AccountSettings: { FeatureSettings: { EnableUserEffectiveDoc: value } }
                    })
                })
        })
    }

    render() {
        return (
            <div style={this.props.accountManager && { overflow: "auto", height: "calc(100vh - 250px)" }}>
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Timecards}`}
                        toggled={this.state.enableTimecards}
                        onToggle={this.handleToggleEnableTimecards}
                        label={strings.Enable_Timecards}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="When disabled this hides the Timecards view in the account."
                    />
                    {this.state.enableTimecards &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Create_Empty_Timecard}`}
                            toggled={this.state.enableCreateEmptyTimecard}
                            onToggle={this.handleToggleEnableCreateEmptyTimecard}
                            label={strings.Enable_Create_Empty_Timecard}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Creates an empty timecard for employees even when there are no hours. This is so that all employees show up under Timecards - even if they haven't worked that week"
                        />
                    }
                </div>
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Equipment}`}
                    toggled={this.state.enableEquipment}
                    onToggle={this.handleToggleEnableEquipment}
                    label={strings.Enable_Equipment}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Enabled the Equipment view and functionality. It allows Equipment to be set up and selected by employees when punching"
                />
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Payroll}`}
                        toggled={this.state.enablePayrollWorkflow}
                        onToggle={this.handleToggleEnablePayrollWorkflow}
                        label={strings.Enable_Payroll}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Enables Payroll to be used in the account"
                    />
                    {this.state.enablePayrollWorkflow &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Payroll_Lambda}`}
                            toggled={this.state.enablePayrollLambda}
                            onToggle={this.handleToggleEnablePayrollLambda}
                            label={strings.Enable_Payroll_Lambda}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Used for larger clients who use payroll (not tested fully, QA does not recommend right now)"
                        />
                    }
                    {this.state.enablePayrollWorkflow &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Disable_Accrual_Calculation_For_Payroll}`}
                            toggled={this.state.disableAccrualCalculationForPayroll}
                            onToggle={this.handleToggleDisableAccrualCalculationForPayroll}
                            label={strings.Disable_Accrual_Calculation_For_Payroll}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Wil disable the accrual calculations when payroll is closed"
                        />
                    }
                    {this.state.enablePayrollWorkflow &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Show_All_Employees_In_Payroll}`}
                            toggled={this.state.showEmptyEmployeePayroll}
                            onToggle={this.handleToggleShowEmptyEmployeePayroll}
                            label={strings.Show_All_Employees_In_Payroll}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Will show all employes in payroll even if they don't have any hours for the pay period"
                        />
                    }
                </div>
                {this.state.enablePayrollWorkflow && [
                    <div key="exclude" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            toggled={this.state.excludeExemptEmpPayroll}
                            onToggle={this.handleToggleExcludeExemptEmpPayroll}
                            label={strings.Exclude_Exempt_Employees}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Employees who are exempt will be excluded from the payroll view and export"
                        />
                        <InfoIconToggle
                            toggled={this.state.excludeAgencyEmpPayroll}
                            onToggle={this.handleToggleExcludeAgencyEmpPayroll}
                            label={strings.Exclude_Agency_Employees}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info={`Employees who have an employee type of "Agency Staff" will be excluded from the payroll view and export`}
                        />
                    </div>,
                    <div key="lock" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Only_Lock_Supervisor_Approved}`}
                            toggled={this.state.onlyLockSupApproved}
                            onToggle={this.handleToggleOnlyLockSupApproved}
                            label={strings.Only_Lock_Supervisor_Approved}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Payroll will only be allowed to be locked when all timecards are supervisor approved"
                        />
                        {(this.state.enableEmployeeApproveTimecard || this.state.enableExpenses) &&
                            <InfoIconToggle
                                data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Only_Lock_Employee_Approved}`}
                                toggled={this.state.onlyLockEmpApproved}
                                onToggle={this.handleToggleOnlyLockEmpApproved}
                                label={strings.Only_Lock_Employee_Approved}
                                style={{ maxWidth: 275, }}
                                disabled={this.props.readOnly}
                                info="Payroll will only be allowed to be locked when all timecards are employee approved"
                            />
                        }
                    </div>,
                    <div key="other1" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_PayGroup_Assign_Employee_Level}`}
                            toggled={this.state.enablePayGroupAssignEmployeeLevel}
                            onToggle={this.handleToggleEnablePayGroupAssignEmployeeLevel}
                            label={strings.Enable_PayGroup_Assign_Employee_Level}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Adds an option on the employee's profile (under schedule and payroll settings) to assign that employee to a specific pay group"
                        />
                        <InfoIconToggle
                            toggled={this.state.enableOTPolicy}
                            onToggle={this.handleToggleEnableOTPolicy}
                            label={strings.Enable_OT_Policy}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Enables various OT policies for an account.  This can then be used on pay configurations and within hierarchy settings"
                        />
                    </div>,
                    <div key="other2" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={"menu-AccountSettings-Features-Toggle-Suspense_Punches_Resolved_Before_Payroll_Locking"}
                            toggled={this.state.resolveSuspensePunch}
                            onToggle={this.handleToggleResolveSuspensePunch}
                            label="Suspense Punches Resolved Before Payroll Locking"
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                        />
                        <InfoIconToggle
                            toggled={this.state.enableEmployeeLock}
                            onToggle={this.handleToggleEnableEmployeeLock}
                            label={strings.Enable_Employee_Lock}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                        />
                    </div>,
                    <div key="other3" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={"menu-AccountSettings-Features-Toggle-Supervisor-Lock"}
                            toggled={this.state.enableSupervisorLock}
                            onToggle={this.handleToggleEnableSupervisorLock}
                            label="Enable Supervisor Lock"
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Allow Editing Payroll After Lock"
                        />
                    </div>,
                    <div key="other4" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-Hide-Parent-PunchSets-In-Payroll`}
                            toggled={this.state.hideParentPunchSetsInPayroll}
                            onToggle={this.handleHideParentPunchSetsInPayroll}
                            label={strings.Hide_Parent_PunchSets_In_Payroll}
                            style={{ maxWidth: 275, marginBottom: 15 }}
                            disabled={this.props.readOnly}
                            info="Parent Punchsets will be hidden in Payroll View"
                        />
                    </div>,
                    <div key="other5" style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-EnableUserEffectiveDoc`}
                            toggled={this.state.enableUserEffectiveDoc}
                            onToggle={this.handleToggleEnableUserEffectiveDoc}
                            label={strings.Enable_user_effective_Doc}
                            style={{ maxWidth: 275, marginBottom: 15 }}
                            disabled={this.props.readOnly}
                            info="Enable user effective doc"
                        />
                    </div>,
                ]}
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Expenses}`}
                        toggled={this.state.enableExpenses}
                        onToggle={this.handleToggleEnableExpenses}
                        label={strings.Enable_Expenses}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Expenses can be used in the account"
                    />
                    {this.state.enableExpenses &&
                        this.state.enablePayrollWorkflow && [
                            <InfoIconToggle
                                key="payroll_expense_summary"
                                data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Payroll_Expenses_Summary}`}
                                toggled={!this.state.expenseIsPayrollTime}
                                onToggle={(e, value) => this.handleToggleExpenseIsPayrollTime(!value)}
                                label={strings.Payroll_Expenses_Summary}
                                style={{ maxWidth: 275, marginRight: 50 }}
                                disabled={this.props.readOnly}
                                info="Generates separate section on payroll page to show expenses"
                            />,
                            <InfoIconToggle
                                key="payroll_expenses_combined_with_time_data"
                                data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Payroll_Expenses_Combined_with_Time_Data}`}
                                toggled={this.state.expenseIsPayrollTime}
                                onToggle={(e, value) => this.handleToggleExpenseIsPayrollTime(value)}
                                label={strings.Payroll_Expenses_Combined_with_Time_Data}
                                style={{ maxWidth: 275, }}
                                disabled={this.props.readOnly}
                                info="Expense time and payroll time will be combined on Payroll screen - no separate Expense Summary section"
                            />
                        ]
                    }
                </div>
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <div style={{ width: 325 }} />
                    {this.state.enableExpenses &&
                        <InfoIconToggle
                            toggled={this.state.enableTimecardTimeExpenses}
                            onToggle={this.handleToggleEnableTimecardTimeExpenses}
                            label={strings.Enable_Timecard_Time_Expenses}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Expenses section is shown on the timecards view and can be added/edited on specific days"
                        />
                    }
                    {this.state.enableTimecardTimeExpenses &&
                        <InfoIconToggle
                            toggled={this.state.enableTimecardAmountExpenses}
                            onToggle={this.handleToggleEnableTimecardAmountExpenses}
                            label={strings.Enable_Timecard_Amount_Expenses}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                        />
                    }
                </div>
                {this.state.enableTimecardTimeExpenses &&
                    <div style={{ display: "flex", marginBottom: 15, marginLeft: 325 }}>
                        <InfoIconToggle
                            toggled={this.state.enablePriorPeriodAdjustments}
                            onToggle={this.handleToggleEnablePriorPeriodAdjustments}
                            label={strings.Enable_Prior_Period_Adjustment}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                        />
                    </div>
                }
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Accruals_Timeoff}`}
                        toggled={this.state.enableAccrualsTimeoff}
                        onToggle={this.handleToggleEnableAccrualsTimeoff}
                        label={strings.Enable_Accruals_Timeoff}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Allows accruals to be set up in account and allows employees to request time off"
                    />
                    {this.state.enableAccrualsTimeoff &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Manual_Accrual_Adjustment}`}
                            toggled={this.state.enableManualAccrualAdjustment}
                            onToggle={this.handleToggleEnableManualAccrualAdjustment}
                            label={strings.Enable_Manual_Accrual_Adjustment}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Allows account users to edit Employee Accrual Values"
                        />
                    }
                    {this.state.enableAccrualsTimeoff &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.One_Hour_Timeoff_Increment}`}
                            toggled={this.state.oneHourTimeoffIncrement}
                            onToggle={this.handleToggleOneHourTimeoffIncrement}
                            label={strings.One_Hour_Timeoff_Increment}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Normal timeoff increment button will be in 0.01 when this feature is enabled it will increase to 1"
                        />
                    }
                </div>
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Schedule}`}
                        toggled={this.state.enableSchedule}
                        onToggle={this.handleToggleEnableSchedule}
                        label={strings.Enable_Schedule}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Schedules can be set up and assigned to employees within the account"
                    />
                    {this.state.enableSchedule &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Work_Availability}`}
                            toggled={this.state.enableWorkAvailavility}
                            onToggle={this.handleToggleEnableWorkAvailability}
                            label={strings.Enable_Work_Availability}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Employees will be able to set their work availability that can then be viewed by managers/admin in Grandd Central and also on the employee mobile view"
                        />
                    }
                    {this.state.enableSchedule &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Daily_Schedule_Budget}`}
                            toggled={this.state.enableDailyScheduleBudget}
                            onToggle={this.handleToggleEnableDailyScheduleBudget}
                            label={strings.Daily_Schedule_Budget}
                            style={{ maxWidth: 275, }}
                            disabled={this.props.readOnly}
                            info="Shows the day budget in the schedule planner and posted schedule section on Schedules tab"
                        />
                    }
                </div>
                {this.state.enableSchedule &&
                    <div style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Resource_Planner_Schedule}`}
                            toggled={this.state.enableResourcePlannerSchedule}
                            onToggle={this.handleToggleEnableResourcePlannerSchedule}
                            label={strings.Resource_Planner_Schedule}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Creates a toggle in posted schedules that can be turned on or off that shows a detailed view of schedules such as employees working their start/end times, and job/hierarchy details"
                        />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Work_Instructions}`}
                            toggled={this.state.enableWorkInstructions}
                            onToggle={this.handleToggleEnableWorkInstructions}
                            label={strings.Work_Instructions}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Adds the ability to define the work as part of the daily schedule budget"
                        />
                    </div>
                }
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Employee_Approve_Timecard}`}
                        toggled={this.state.enableEmployeeApproveTimecard}
                        onToggle={this.handleToggleEnableEmployeeApproveTimecard}
                        label={strings.Enable_Employee_Approve_Timecard}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Allows employees to approve their timecards"
                    />
                    {this.state.enableEmployeeApproveTimecard &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Disable_Employee_Approval_Exceptions_Notify}`}
                            toggled={this.state.disableEmployeeApprovalException}
                            onToggle={this.handleToggleDisableEmployeeApprovalException}
                            label={strings.Disable_Employee_Approval_Exceptions_Notify}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Disables exception notifications if an employee does not approve their timecard"
                        />
                    }
                </div>
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_External_Supervisor_Approve_Timecard}`}
                    toggled={this.state.enableExtSupApproveTimecard}
                    onToggle={this.handleToggleEnableExtSupApproveTimecard}
                    label={strings.Enable_External_Supervisor_Approve_Timecard}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="External supervisors can approve timecards. (Applicable for ESS users)"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Supervisor_Direct_Report}`}
                    toggled={this.state.enableSupervisorDirectReport}
                    onToggle={this.handleToggleEnableSupervisorDirectReport}
                    label={strings.Enable_Supervisor_Direct_Report}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Allows employees to be directly assigned to an admin/manager/user.  That manager then can choose to only view their direct reports"
                />
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${checkJobFieldAvailable('plural') ? `Enable ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Enable_Jobs}`}
                        toggled={this.state.enableJobs}
                        onToggle={this.handleToggleEnableJobs}
                        label={checkJobFieldAvailable('plural') ? `Enable ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Enable_Jobs}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Allows Jobs to be set up within a hierarchy/hierarchies within the account"
                    />
                    {this.state.enableJobs && [
                        <InfoIconToggle
                            key="enable_phase"
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Phases}`}
                            toggled={this.state.enablePhases}
                            onToggle={this.handleToggleEnablePhases}
                            label={checkPhaseFieldAvailable("plural") ? `Enable ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.PluralPhaseLabel}` : strings.Enable_Phases}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Allows Phases to be defined at the job level and for mobile users to punch to when they are working a specific job"
                        />,
                        <InfoIconToggle
                            key="disable_assign_job_punch"
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Punch_to_Assigned_Jobs_Only}`}
                            toggled={this.state.enableAssignJobPunch}
                            onToggle={this.handleToggleEnableAssignJobPunch}
                            label={strings.Enable_Punch_to_Assigned_Jobs_Only}
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                            info="Creates a toggle on employees profile (user policy menu) that can be turned on or off to have employee punch only to assigned jobs"
                        />
                    ]}
                </div>
                {this.state.enableJobs &&
                    <div style={{ display: "flex", marginBottom: 15 }}>
                        <div style={{ width: 325 }} />
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-Enable_Job_Timezone`}
                            toggled={this.state.enableJobTimezone}
                            onToggle={this.handleToggleEnableJobTimezone}
                            label={strings.Enable_Job_Timezone}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                        />
                    </div>
                }
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Punch_Split_At_Day_Boundary}`}
                    toggled={this.state.enablePunchSplit}
                    onToggle={this.handleToggleEnablePunchSplit}
                    label={strings.Enable_Punch_Split_At_Day_Boundary}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Two punches at 12am will auto generate in between two days if an employee works overnight in the same punchset"
                />
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_PayClass}`}
                        toggled={this.state.enablePayClass}
                        onToggle={this.handleToggleEnablePayClass}
                        label={strings.Enable_PayClass}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Enables pay class to be added for different positions"
                    />
                    {
                        this.state.enableUseBasePayRateInPayClass &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-${strings.Allow_Time_Off_PayRate_Edit}`}
                            toggled={this.state.allowTimeOffPayRateEdit}
                            onToggle={this.handleToggleAllowTimeOffPayRateEdit}
                            label={strings.Allow_Time_Off_PayRate_Edit}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Pay Rate will be editable in Leave Request"
                        />
                    }
                    {this.state.enableUseBasePayRateInPayClass && <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Use_Base_Pay_Rate_In_PayClass}`}
                        toggled={this.state.enableUseBasePayRateInPayClass}
                        onToggle={this.handleToggleEnableUseBasePayRateInPayClass}
                        label={strings.Enable_Use_Base_Pay_Rate_In_PayClass}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Enables pay class to be added for different positions"
                    />}
                    {this.state.enableCRM &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-ShowPayClassOnESS`}
                            toggled={this.state.showPayClassOnESS}
                            onToggle={this.handleToggleShowPayClassOnESS}
                            label="Show PayClass On ESS"
                            style={{ maxWidth: 275 }}
                            disabled={this.props.readOnly}
                        />
                    }
                </div>
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Clients}`}
                    toggled={this.state.enableClients}
                    onToggle={this.handleToggleEnableClients}
                    label={strings.Enable_Clients}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="This will enable the clients feature that can be used to be assigned to hierarchies or jobs"
                />
                {this.state.enableClients &&
                    <div style={{ display: "flex", marginBottom: 15 }}>
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_HR}`}
                            toggled={this.state.enableHR}
                            onToggle={this.handleToggleEnableHR}
                            label={strings.Enable_HR}
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                            info="Enables the HR feature for the account"
                        />
                        {this.state.enableHR &&
                            <InfoIconToggle
                                data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_CWM}`}
                                toggled={this.state.enableCRM}
                                onToggle={this.handleToggleEnableCRM}
                                label={strings.Enable_CWM}
                                style={{ maxWidth: 275 }}
                                disabled={this.props.readOnly}
                                info="Jobs attribute functionality. (Able to assign shifts, set start date, end date, etc)"
                            />
                        }
                        {this.state.enableHR &&
                            <InfoIconToggle
                                data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Note_Attributes}`}
                                toggled={this.state.enableNoteAttributes}
                                onToggle={this.handleToggleEnableNoteAttributes}
                                label={strings.Enable_Note_Attributes}
                                style={{ maxWidth: 275, marginLeft: 20 }}
                                disabled={this.props.readOnly}
                                info="Ability to add notes in HR"
                            />
                        }
                    </div>
                }
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Calculation_Day_Group}`}
                    toggled={this.state.enableCalculationDayGroup}
                    onToggle={this.handleToggleEnableCalculationDayGroup}
                    label={strings.Enable_Calculation_Day_Group}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Enables day grouping on timecard (overnight punch sets will be moved to the next day)"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Policy_For_Account}`}
                    toggled={this.state.enableFinddPolicy}
                    onToggle={this.handleToggleEnableFinddPolicy}
                    label={strings.Enable_Policy_For_Account}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info={`Enables the "Findd Biometric Agreement" to be presented on mobile devices within the account`}
                />
                <div style={{ display: "flex", marginBottom: 15 }}>
                    <InfoIconToggle
                        data-intercom-target={`menu-AccountSettings-Features-Toggle-Punch-Rule`}
                        toggled={this.state.enablePunchRule}
                        onToggle={this.handleToggleEnablePunchRule}
                        label={strings.Enable_Punch_Rule}
                        style={{ maxWidth: 275, marginRight: 50 }}
                        disabled={this.props.readOnly}
                        info="Allows Punch Rules to be set up within the account"
                    />
                    {this.state.enablePunchRule &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-EnablePunchRuleStage`}
                            toggled={this.state.enablePunchRuleStage}
                            onToggle={this.handleToggleEnablePunchRuleStage}
                            label="Enable Punch Rule Stage"
                            style={{ maxWidth: 275, marginRight: 50 }}
                            disabled={this.props.readOnly}
                        />
                    }
                    {this.state.enablePunchRule && this.state.enableSchedule &&
                        <InfoIconToggle
                            data-intercom-target={`menu-AccountSettings-Features-Toggle-Recalculate_Timecard_On_Shift_Change`}
                            toggled={this.state.recalcTimecardByShift}
                            onToggle={this.handleToggleRecalcTimecardByShift}
                            label="Recalculate Timecard On Shift Change"
                            style={{ maxWidth: 300 }}
                            disabled={this.props.readOnly}
                            info="Timecards will be recalculated when a shift is adjusted within an account to ensure punch rules to be applied properly"
                        />
                    }
                </div>
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Force_Employee_Account_Position}`}
                    toggled={this.state.forceEmployeeAccountPosition}
                    onToggle={this.handleToggleForceEmployeeAccountPosition}
                    label={checkPositionFieldAvailable('singular') ? `Force Employee Account ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.Force_Employee_Account_Position}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Employee positions are copied from account positions and no new employee positions can be added"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Hide_Billing_Menu}`}
                    toggled={this.state.hideBilling}
                    onToggle={this.handleToggleHideBilling}
                    label={strings.Hide_Billing_Menu}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="This will determine whether or not the billing menu is displayed on user's account"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_Custom_Break_Rounding_Rule}`}
                    toggled={this.state.enableCustomRoundingRule}
                    onToggle={this.handleToggleEnableCustomRoundingRule}
                    label={strings.Enable_Custom_Break_Rounding_Rule}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="A custom break rounding rule can be created within an account if turned on"
                />
                <InfoIconToggle
                    toggled={this.state.enableRateTotals}
                    onToggle={this.handleToggleEnableRateTotals}
                    label={strings.Enable_Rate_Totals}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Bill rate, burden, net, and total times will be shown on the timecard"
                />
                <InfoIconToggle
                    toggled={this.state.showPayrollRates}
                    onToggle={this.handleToggleShowPayrollRates}
                    label={strings.Show_Payroll_Rates}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Pay amount will be shown on payroll screen and on payroll reports"
                />
                <InfoIconToggle
                    toggled={this.state.enableWorkflows}
                    onToggle={this.handleToggleEnableWorkflows}
                    label={strings.EnableWorkflows}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Enables training instructions/workflows for newly created accounts"
                />
                <InfoIconToggle
                    toggled={this.state.allowSTRIPEPaymentMethod}
                    onToggle={this.handleToggleAllowSTRIPEPaymentMethod}
                    label={strings.Allow_STRIPE_Payment_Method}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly ? true : this.props.account.IsFinddTestAccount}
                />
                <InfoIconToggle
                    toggled={this.state.hidePaywall}
                    onToggle={this.handleToggleHidePaywall}
                    label={strings.Hide_Paywall}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Upgrade plan window for newly creating account for features that are not enabled for the account"
                />
                <InfoIconToggle
                    toggled={this.state.hideOT2}
                    onToggle={this.handleToggleHideOT2}
                    label={strings.Hide_OT2}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Will hide the OT2 category on the timecard totals"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Disable_Supervisor_Approval_Exception_Notify}`}
                    toggled={this.state.disableSupervisorApprovalException}
                    onToggle={this.handleToggleDisableSupervisorApprovalException}
                    label={strings.Disable_Supervisor_Approval_Exception_Notify}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Disables notifications for supervisors that didn't approve timecards"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${checkJobFieldAvailable('singular') ? `Disable Creating Location Exception When No Hierarchy/${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} GPS Is Set` : strings.Disable_Creating_Location_Exception_When_No_GPS}`}
                    toggled={this.state.disableLocationExceptionWhenNoGPS}
                    onToggle={this.handleToggleDisableLocationExceptionWhenNoGPS}
                    label={checkJobFieldAvailable('singular') ? `Disable Creating Location Exception When No Hierarchy/${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} GPS Is Set` : strings.Disable_Creating_Location_Exception_When_No_GPS}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="When a hierarchy or job is not set up with a location, this will disable a location exception from being received"
                />
                <InfoIconToggle
                    toggled={this.state.allowMobileLocationFraudPreventionOnDevice}
                    onToggle={this.handleToggleAllowMobileLocationFraudPreventionOnDevice}
                    label={strings.Enable_Mobile_Location_Fraud_Prevention}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Mobile Fraud Prevention is to catch employees from manually changing a device time or putting on airplane mode on a device to manipulate time when using a mobile clock mode or individual mode device"
                />
                <InfoIconToggle
                    toggled={this.state.enableBreadcrumb}
                    onToggle={this.handleToggleEnableBreadcrumb}
                    label={strings.Enable_Breadcrumb}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="If an employee travels after punching in, the mobile app sends the travel path to Grandd Central after a set interval of time"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.MedicalAccount}`}
                    toggled={this.state.medicalAccount}
                    onToggle={this.handleToggleMedicalAccount}
                    label={strings.MedicalAccount}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Changes workflow that will include fill rate %, utilization %, overtime %, agency employee pay information"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_CA_Meal_Break_Notification}`}
                    toggled={this.state.enableCAMealBreakNotification}
                    onToggle={this.handleToggleEnableCAMealBreakNotification}
                    label={strings.Enable_CA_Meal_Break_Notification}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Per CA law, when an employee works for more than 5 hours, they will automatically receive a meal break notification"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.Enable_CA_Meal_Break_Notification}`}
                    toggled={this.state.eanbleChatGPTAutoRespondToSMS}
                    onToggle={this.handleToggleEanbleChatGPTAutoRespondToSMS}
                    label={strings.AutoReplyChatGPT}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Chat GPT will automate responses to SMS messages sent by employees"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-${strings.EnableBlendedRateOT}`}
                    toggled={this.state.enableBlendedRateOvertime}
                    onToggle={this.handleToggleEnableBlendedRateOvertime}
                    label={strings.EnableBlendedRateOT}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Blended rate OT will be enabled on timecards (includes different wages for different jobs, bonuses etc)"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-Trends`}
                    toggled={this.state.enableTrends}
                    onToggle={this.handleToggleEnableTrends}
                    label={"Enable Trends"}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Dashboard will show Trend Analysis"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-ATS`}
                    toggled={this.state.enableATS}
                    onToggle={this.handleToggleEnableATS}
                    label={strings.Enable_ATS}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="HR will show Job-Posting menu"
                />

                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-IVR`}
                    toggled={this.state.enableIVR}
                    onToggle={this.handleToggleEnableIVR}
                    label={"Enable IVR Punch by Phone"}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Enable the ability to add phone numbers to hiearrchy, job, and devices to determine IVR/Phone based punch settings"
                />

                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-EnableSimpleWorkPreferences`}
                    toggled={this.state.enableSimpleWorkPreferences}
                    onToggle={this.handleToggleEnableSimpleWorkPreferences}
                    label={strings.Enable_Simple_Work_Preferences}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="ESS will show simple work preferences for employee"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-ATS`}
                    toggled={this.state.enableMessageCenter}
                    onToggle={this.handleToggleEnableMessageCenter}
                    label={strings.Enable_Message_Center}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="HR will show Message-Center menu"
                />
                <InfoIconToggle
                    data-intercom-target={`menu-AccountSettings-Features-Toggle-EnableDidiNotifications`}
                    toggled={this.state.enableDidiNotifications}
                    onToggle={this.handleToggleEnableDidiNotifications}
                    label={strings.Enable_Didi_Notifications}
                    style={{ maxWidth: 275, marginBottom: 15 }}
                    disabled={this.props.readOnly}
                    info="Enable Didi Nudges"
                />
                {!this.props.accountManager &&
                    <AccountPerEmployeePerMonthRate
                        accountManager={this.props.accountManager}
                        account={this.props.account}
                        updateLoadedAccount={this.props.updateLoadedAccount}
                        readOnly={this.props.readOnly}
                    />
                }
            </div>
        )
    }
}
